<script lang="ts">
  import { Search, Plus } from 'lucide-svelte';

  let {
    value = $bindable(''),
    onCreate,
    createLabel = 'New'
  }: { value: string; onCreate?: () => void; createLabel?: string } = $props();
</script>

<div class="flex items-center gap-3 mb-4">
  <div class="relative flex-1 max-w-sm">
    <Search class="absolute left-2.5 top-2.5 h-4 w-4 text-dark-gray pointer-events-none" />
    <!-- `!` forces this to win over .input's own px-3 (which the plain
         .input{} rule in app.css, declared after @tailwind utilities,
         would otherwise beat on source order alone) — without it the icon
         sits on top of the placeholder text instead of beside it. -->
    <input type="search" placeholder="Search..." bind:value class="input !pl-8" />
  </div>
  {#if onCreate}
    <button type="button" class="btn-primary" onclick={onCreate}>
      <Plus class="h-4 w-4" />
      {createLabel}
    </button>
  {/if}
</div>
